import * as Sentry from '@sentry/svelte'
import { PUBLIC_NODE_ENV, PUBLIC_SERVER_URL } from '$env/static/public'
import { FRONTEND_VERSION } from './lib/utils/version-check'
import { inDevelopment } from './env'

// Initialize the Sentry SDK here
Sentry.init({
  sendDefaultPii: true,
  dsn: 'https://bbc62b28fc7627385f3c8b2b11de205b@o4507185626742784.ingest.de.sentry.io/4507191544840272',
  tunnel: `${PUBLIC_SERVER_URL}/api/sentry-tunnel`,
  environment: PUBLIC_NODE_ENV,
  release: `fixee-web@${FRONTEND_VERSION}`,
  beforeSend: event => {
    if (inDevelopment()) return null

    return event
  },
})
